export default {
	"delivery.ThereIsNoLogisticalInformation": "暂无任何物流信息",
	"delivery.ParameterError": "参数错误!"
}